import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Child from './model';

export const createChild = (
    institutionId,
    name,
    startDate,
    birthDay,
    groupId,
    gender,
    createRelationForLogin = false,
    extraInfo = null,
    endDate,
    language,
    nationality,
    birthplace,
    suppressErrors = false,
) => {
    return RESTClient.postAuthenticatedObservable(
        'v2/children',
        {
            institutionId,
            name,
            startDate,
            birthDay,
            groupId,
            gender,
            createRelationForLogin,
            extraInfo,
            endDate,
            language,
            nationality,
            birthplace,
        },
        {suppressErrors},
    ).map(child => Child.fromAPI(child));
};

export const fetchChildren = (
    institutionId,
    embedRelations,
    includeFuture,
    includePast,
    groupIds,
    tagIds,
    alwaysShowPickup,
) => {
    return RESTClient.getAuthenticatedObservable('v2/children', {
        institutionId,
        embedRelations,
        future: includeFuture,
        past: includePast,
        groupIds,
        tagIds,
        alwaysShowPickup,
    }).map(response => List(response.map(Child.fromAPI)));
};

export const fetch = childId => {
    return RESTClient.getAuthenticatedObservable(`v2/children/${childId}/summary`).map(response => ({
        child: Child.fromAPI(response.child),
        napsSummary: response.naps,
    }));
};

export const updateGroup = (childId, groupId) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}`, {
        groupId,
    }).map(child => Child.fromAPI(child));
};

export const fetchBasicChildInfo = childId => {
    return RESTClient.getAuthenticatedObservable(`v2/children/${childId}/summary`).map(response =>
        Child.fromAPI({...response.child, relations: response.relations}),
    );
};

export const updateBasicChildInfo = (childId, child) => {
    return RESTClient.postAuthenticatedObservable(`v2/children/${childId}`, {
        ...child,
    }).map(response => Child.fromAPI(response));
};

export const addTag = (childId, tagId) => {
    return RESTClient.postAuthenticatedObservable(`v2/tags/${tagId}/assign`, {childId});
};

export const removeTag = (childId, tagId) => {
    return RESTClient.postAuthenticatedObservable(`v2/tags/${tagId}/unassign`, {childId});
};

export const updateKeyWorkers = (childId, employees) =>
    RESTClient.putAuthenticatedObservable(`v2/children/${childId}/key-workers`, {
        employees,
    }).map(response => Child.keyWorkersFromAPI(response.employees));

export const checkIn = (childId, groupId) =>
    RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkins`, {groupId});

export const checkOut = childId => RESTClient.postAuthenticatedObservable(`v2/children/${childId}/checkout`);

export const getKikuChild = childId =>
    RESTClient.getAuthenticatedObservable(`v2/kiku-child/${childId}`).map(response =>
        Child.kikuChildFromApi(response.kikuChild),
    );

export const updateKikuChild = (childId, kikuChild) =>
    RESTClient.postAuthenticatedObservable(`v2/kiku-child/${childId}`, {kikuChild}).map(response =>
        Child.kikuChildFromApi(response.kikuChild),
    );

export const getAutoGeneratedChildId = childId =>
    RESTClient.getAuthenticatedObservable(`v2/children/auto-generated-ids?childIds[]=${childId}`);
export const updateAutoGeneratedChildId = (childId, id) =>
    RESTClient.postAuthenticatedObservable('v2/children/auto-generated-ids', {childId, id});
